import { API_COUPON_SHOP_LIST } from '@utils/api'
import $ from '@utils/axios'

export const state = {
  scrollTop: 0, // 外部要素のulのスクロール高さ
  fcScrollTopMap: {}, // すべての複数の施設のスクロール高さ
  isSetShops: false,
  shops: [],
}

export const getters = {
  scrollTop: (state) => {
    return state.scrollTop
  },
  fcScrollTopMap: (state) => {
    return state.fcScrollTopMap
  },
}

export const mutations = {
  updateScrollHeight: (state, newVal) => {
    state.scrollTop = newVal
  },
  updateFcScrollTopMap: (state, newVal) => {
    state.fcScrollTopMap = newVal
  },
  SET_ISSETSHOPS(state, newValue) {
    state.isSetShops = newValue
  },
  SET_SHOPS(state, newValue) {
    state.shops = newValue
  },
}

export const actions = {
  changeScrollTop: ({ state, commit }, val) => {
    commit('updateScrollHeight', val)
  },
  changeFcScrollTopMap: ({ state, commit }, val) => {
    commit('updateFcScrollTopMap', val)
  },
  setShops({ commit, state, rootState }, shops) {
    commit('SET_SHOPS', shops)
    commit('SET_ISSETSHOPS', true)
  },
  async fetchShops(
    { commit, state, rootState },
    { id, longitude, latitude, sort }
  ) {
    const params = {}
    params.session_id = rootState.auth.sessionId
    params.COUPON_NO = id
    params.LONGITUDE = 0.0
    params.LATITUDE = 0.0
    params.MODE = 2
    params.SORT = sort
    if (longitude) {
      params.LONGITUDE = longitude
    }
    if (latitude) {
      params.LATITUDE = latitude
    }
    params.customConfig = {
      withoutLoading: true,
    }

    try {
      var formData = new FormData();
      for (var k in params) {
        if (k === "customConfig") { continue; }
        formData.append(k, params[k] ?? "");
      }

      const response = await $.post(API_COUPON_SHOP_LIST, formData)
      // if (response.data.status_code !== '00') {
      //   throw new Error(response.data.error_code)
      // }
      // if (
      //   Object.keys(response.data.coupon).length === 0 &&
      //   response.data.coupon.constructor === Object
      // ) {
      //   const e = new Error('このクーポンの掲載は終了しました。')
      //   e.name = 'noCoupon'
      //   throw e
      // }
      return response.data.shop
    } catch (e) {
      //   if (e.message === 'Network Error') {
      //     const error = new Error(
      //       '通信に失敗しました。通信状況を確認し、再度お試し下さい'
      //     )
      //     error.name = 'networkError'
      //     throw error
      //   } else {
      //     throw e
      //   }
    }
  },
}
